var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_1582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6937 14.7375H8.30625C3.72656 14.7375 0 18.4641 0 23.0438C0 23.5594 0.421875 23.9813 0.9375 23.9813H23.0625C23.5781 23.9813 24 23.5594 24 23.0438C24 18.4641 20.2734 14.7375 15.6937 14.7375ZM1.94531 22.1063C2.4 19.0032 5.08125 16.6125 8.31094 16.6125H15.6937C18.9234 16.6125 21.6047 19.0032 22.0594 22.1063H1.94531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0969C15.6047 13.0969 18.5391 10.1625 18.5391 6.55786C18.5391 2.95317 15.6047 0.0187988 12 0.0187988C8.39531 0.0187988 5.46094 2.95317 5.46094 6.55786C5.46094 10.1625 8.39531 13.0969 12 13.0969ZM12 1.8938C14.5781 1.8938 16.6641 3.97974 16.6641 6.55786C16.6641 9.13599 14.5781 11.2219 12 11.2219C9.42188 11.2219 7.33594 9.13599 7.33594 6.55786C7.34063 3.98442 9.42656 1.89849 12 1.8938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_1582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProfile);
export default __webpack_public_path__ + "static/media/active_profile.ad9290c450e7db6052427e5275568c51.svg";
export { ForwardRef as ReactComponent };